// extracted by mini-css-extract-plugin
export default {"mCard":"Rz-z","image":"Sz-z","imageNoBackground":"Tz-z","imageHasCategory":"Uz-z","fullWidth":"Vz-z"};